export const CHANGE_INPUT_FIELD = 'CHANGE_INPUT_FIELD';
export const SEARCH_ROBOTS_PENDING = 'SEARCH_ROBOTS_PENDING';
export const SEARCH_ROBOTS_SUCCESS = 'SEARCH_ROBOTS_SUCCESS';
export const SEARCH_ROBOTS_FAILED = 'SEARCH_ROBOTS_FAILED';